import { makeStyles } from "@material-ui/core";

export const learningPathStyles = makeStyles((theme) => ({
  container: {
    background: "white",
    display: "flex",
    flexDirection: "row",
  },
  imageContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexGrow: 1,
    "& svg": {
      boxSizing: "content-box",
      padding: "10px 25px",
    },
  },
  mxContainer: {
    margin: "auto",
  },
  appContainer: {
    padding: "5px 25px 5px 25px",
    display: "flex",
    justifyContent: "center",
    backgroundColor: "#FFFFFF",
    boxShadow: "0px 0px 25px rgba(0, 0, 0, 0.1)",
    height: "70px",
    position: "relative",
    "& a": {
      "& p": {
        color: "#000000",
        fontFamily: "Lato",
        fontWeight: 400,
        fontSize: theme.typography.pxToRem(16),
        display: "flex",
        alignItems: "center",
      },
    },
  },
  innerContainer: {
    alignItems: "center",
    justifyContent: "center",
  },
  oneOnOneQuickWin: {
    width: "634px",
    margin: "auto",
  },
}));
